import * as actionTypes from '../../constants/actionTypes';

import { CALL_PRIVATE_API } from '../../middleware/api';
import * as resourceTypes from '../../constants/resourceTypes';
import { getCurrentUser } from '../../reducers/selectors';
import {
  sourceSchema,
  dataSetSchema,
  sinkSchema,
  dataMapSchema,
  transformSchema,
  schemaSpecSchema,
  projectSchema,
} from '../../schemas';
import { GET, POST, PUT } from '../../constants/requestMethods';
import { isStateOneDayOld } from '../../lib/StateUtils';
import isNil from 'lodash/isNil';
import has from 'lodash/has';

export const getAllTags =
  (forceFetch = false) =>
  (dispatch, getState) => {
    const state = getState();
    const { tags } = state;

    let shouldFetchTags = forceFetch === true ? true : false;
    if (!shouldFetchTags) {
      //if not force fetch, check if tags are > 1 day old
      shouldFetchTags =
        isNil(tags) || !has(tags, 'lastUpdated') || isStateOneDayOld(tags.lastUpdated);
    }

    if (!shouldFetchTags) {
      return;
    }

    const user = getCurrentUser(state);

    if (!user) {
      return;
    }

    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.GET_TAGS_REQUEST,
          actionTypes.GET_TAGS_SUCCESS,
          actionTypes.GET_TAGS_FAILURE,
        ],
        endpoint: `/users/${user.id}/tags`,
        schema: null,
        requestMethod: GET,
      },
    });
  };

export const selectTags = (tags) => ({
  type: actionTypes.SELECT_TAGS,
  tags,
});

export const saveTagsOnResource = (resourceId, resourceType, tags) => (dispatch) => {
  let endpoint;
  let schema;
  let requestMethod = POST;
  switch (resourceType) {
    case resourceTypes.RESOURCE_TYPE_SOURCE:
      endpoint = `/data_sources/${resourceId}/tags`;
      schema = sourceSchema;
      break;
    case resourceTypes.RESOURCE_TYPE_DATA_SET:
      endpoint = `/data_sets/${resourceId}/tags`;
      schema = dataSetSchema;
      break;
    case resourceTypes.RESOURCE_TYPE_SINK:
      endpoint = `/data_sinks/${resourceId}/tags`;
      schema = sinkSchema;
      break;
    case resourceTypes.RESOURCE_TYPE_DATA_MAP:
      endpoint = `/data_maps/${resourceId}/tags`;
      schema = dataMapSchema;
      break;
    case resourceTypes.RESOURCE_TYPE_ATTR_TRANSFORM:
    case resourceTypes.RESOURCE_TYPE_RECORD_TRANSFORM:
      endpoint = `/code_containers/${resourceId}/tags`;
      schema = transformSchema;
      break;

    case resourceTypes.RESOURCE_TYPE_SCHEMA_SPECS:
      endpoint = `/data_schemas/${resourceId}/tags`;
      schema = schemaSpecSchema;
      break;

    case resourceTypes.RESOURCE_TYPE_PROJECTS:
      endpoint = `/projects/${resourceId}/tags`;
      schema = projectSchema;
      requestMethod = POST;
      break;

    default:
      endpoint = null;
      schema = null;
  }

  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.ADD_TAGS_REQUEST,
        actionTypes.ADD_TAGS_SUCCESS,
        actionTypes.ADD_TAGS_FAILURE,
      ],
      endpoint,
      schema,
      requestMethod,
      payload: {
        tags,
      },
      requestInfo: {
        tags,
      },
    },
  });
};
